// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cWfTB","disabled":"styles_disabled__i-JZd","active":"styles_active__1j0Gx"};